// Static company information (not managed by CMS)

export const companyInfo = {
  name: "Florentina Infra",
  legalName: "Florentina Infra LLP",
  tagline: "Building Tomorrow's Infrastructure Today",
  description: "Leading construction company in Ahmedabad specializing in residential, commercial, infrastructure, and interior design projects. With years of experience and a commitment to excellence, we transform visions into reality.",
  location: "Bopal, Ahmedabad, Gujarat, India",
  phone: "+91 79 1234 5678",
  email: "info@florentinainfra.com",
  address: "508-510, Shaligram Arcade, Bopal, Ahmedabad, Gujarat, India 380058",
  coordinates: { lat: 23.0225, lng: 72.5714 }
};

export const stats = [
  { label: "Projects Completed", value: "250+" },
  { label: "Years of Experience", value: "15+" },
  { label: "Happy Clients", value: "500+" },
  { label: "Team Members", value: "100+" }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Patel",
    company: "Patel Developers",
    role: "CEO",
    content: "Florentina Infra delivered our commercial complex ahead of schedule with exceptional quality. Their attention to detail and project management skills are outstanding.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    company: "Sharma Residency",
    role: "Project Owner",
    content: "Our dream home became a reality thanks to Florentina Infra. Their team was professional, transparent, and delivered exactly what we envisioned.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Mehta",
    company: "TechCorp India",
    role: "Facilities Manager",
    content: "The interior fit-out for our new office exceeded expectations. Florentina Infra understood our requirements perfectly and executed flawlessly.",
    rating: 5
  },
  {
    id: 4,
    name: "Neha Desai",
    company: "Urban Living Pvt Ltd",
    role: "Director",
    content: "Professional, reliable, and innovative. Florentina Infra has been our go-to partner for multiple residential projects. Highly recommended!",
    rating: 5
  }
];
